export enum SpeedTestState {
  IDEAL = 'IDEAL',
  PINGING = 'PINGING',
  UPLOADING = 'UPLOADING',
  DOWNLOADING = 'DOWNLOADING',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  CANCELLED = 'CANCELLED',
}
